import store from 'Stores';

export default function (to, from, next) {
  if (!store.getters['user/canTest']) {
    next(false);
  } else {
    next(true);
  }
}
